module.exports = __webpack_public_path__ + "img/05.2095b68c.webp";